import PopupContainer from './PopupContainer';

export default PopupContainer;
